import {searchByPhoneAPI} from "./api";

export const searchByPhone = async (phoneNumber) => {
  try {
    const res = await searchByPhoneAPI.search({phone_number: phoneNumber})
    return res?.data
  } catch (e) {
  }
}